import { creatorsBySlug } from './catalog';

const STORAGE_KEY = 'retro-profiles-followed-creators-v1';
const DEFAULT_FOLLOWED_CREATORS = ['wobbling-pixels', 'firebrandx', 'sdmasteryoda'];

export function readFollowedCreators(): string[] {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored !== null) {
      const parsed: unknown = JSON.parse(stored);
      if (Array.isArray(parsed)) return [...new Set(parsed.filter((slug): slug is string => typeof slug === 'string' && creatorsBySlug.has(slug)))];
    }
  } catch {
    // The demo remains usable when browser storage is unavailable.
  }
  return DEFAULT_FOLLOWED_CREATORS.filter((slug) => creatorsBySlug.has(slug));
}

export function saveFollowedCreators(slugs: string[]): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(slugs));
  } catch {
    // The current session still keeps its follow selections in React state.
  }
}
